export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass – Stream Live NBA Games | NBA.com',
	seo_meta_desc_leaguepass: 'Stream NBA games, live and on demand on with League Pass. Access your account here.',
	seo_meta_keywords_leaguepass: 'NBA Videos, NBA Highlights, Basketball Videos, top plays, dunks, features',
	seo_meta_title_featured: 'Stream NBA Games & Watch Highlights | NBA.com',
	seo_meta_desc_featured: 'Watch free NBA video highlights, news, and analysis. Also, explore NBA TV & League Pass subscriptions to watch live games on your favorite devices.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - Stream Live Games And Around-The-Clock Coverage | NBA.com',
	seo_meta_desc_nbatv: 'Stream NBA TV games live or watch iconic classic games. Plus, gain access to studio shows and analysis from around the league.',
	seo_meta_keywords_nbatv: 'NBA TV Channel, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, the jump',
	seo_meta_title_classicgames: 'Stream Classic Games with NBA TV & More | NBA.com',
	seo_meta_desc_classicgames: 'Stream iconic NBA matchups with NBA TV. Also, Stream NBA TV games live and gain access to studio shows and analysis from around the league.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'Stream Content Here | NBA.com',
	seo_meta_title_videolist: 'Stream {0} Here | NBA.com',
	seo_meta_desc_videolist: 'Watch {0} videos here. Also, explore NBA TV & League Pass subscriptions to watch live games on your favorite devices.',
	seo_meta_title_videolist_show: 'Stream {0} with NBA TV | NBA.com',
	seo_meta_desc_videolist_show: 'Watch {0} here. Also, Stream NBA TV games live and gain access to classic games and analysis.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'Stream {0} Here | NBA.com',
	seo_meta_desc_videolist_feed: 'Watch {0} videos here. Also, explore NBA TV & League Pass subscriptions to watch live games on your favorite devices.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Stream Studio Shows with NBA TV & More | NBA.com',
	seo_meta_desc_shows: 'Explore and stream the latest NBA TV Shows and Episodes on demand. Also, Stream NBA TV games live and gain access to classic games and analysis.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Home | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Channels | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Channel | NBA.com',
	seo_meta_pre_title_categories: 'Categories | NBA.com',
	seo_meta_title_categories: 'Categories | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Category | NBA.com',
	seo_meta_title_category: 'Category | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Stream Video Here | NBA.com',
	seo_meta_pre_title_event: 'Stream Event Here | NBA.com',
	seo_meta_title_events: 'Events | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'Stream {0} Here | NBA.com',
	seo_meta_desc_event: 'Watch {0} here. Also, explore NBA TV & League Pass subscriptions to watch live games on your favorite devices.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Search | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Page Not Found | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Stream Game Here | NBA.com',
	seo_meta_title_game: 'Stream {0} Here | NBA.com',
	seo_meta_desc_game: 'Watch {0} here. Also, explore NBA TV & League Pass subscriptions to watch live games on your favorite devices.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'Stream {0} Here | NBA.com',
	seo_meta_desc_video: 'Watch {0} here. Also, explore NBA TV & League Pass subscriptions to watch live games on your favorite devices.',
	seo_meta_keywords_video: 'NBA Videos, NBA Highlights, Basketball Videos, top plays, dunks, features',
	seo_meta_title_episode: 'Stream {0} with NBA TV | NBA.com',
	seo_meta_desc_episode: 'Watch {0} here. Also, Stream NBA TV games live and gain access to classic games and analysis.',
	seo_meta_keywords_episode: 'NBA Videos, NBA Highlights, Basketball Videos, top plays, dunks, features',
	seo_meta_title_channel: 'NBA TV Live | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live is your 24-hour-a-day live stream of NBA TV channel with live and archive NBA games every week, Studio programming and analyst coverage',
	seo_meta_keywords_channel: 'NBA TV Channel, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, the jump',
	seo_meta_title_tvguide: 'NBA TV Live Stream Schedule | NBA.com',
	seo_meta_desc_tvguide: 'See when you can stream NBA TV games live and live studio shows with NBA TV on your favorite device. Plus, access on demand studio shows and analysis.',
	seo_meta_keywords_tvguide: 'NBA TV Channel, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, the jump',

	// Common
	timezone: 'ET',
	default_feed_error_message: 'Something went wrong, the content is not available now. You may be able to try again.',
	watch_in_app: 'WATCH ON NBA APP',
	ad_blocked_message: 'Ad blocker detected. Disable your ad blocker and reload the page.',

	// Item
	no_content: 'No Content',
	see_more: 'See More',
	now_playing: 'NOW PLAYING',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'LEAGUE PASS',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'You have reached the maximum number of favorite videos. Please remove some favorite videos before adding more.',
	item_live: 'LIVE',
	add_favourite_title: 'ADD TO FAVORITE',
	remove_favourite_title: 'REMOVE FROM FAVORITE',
	// Channel: Schedule
	p_channel_live: 'LIVE',
	p_channel_schedule_title: 'NBA TV Schedule',
	p_channel_schedule_watch: 'WATCH',
	p_channel_schedule_no_date: 'Currently no available Schedule Date.',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'See Full Schedule',
	p_channel_live24x7_up_next: 'up next',
	p_channel_live24x7_on_demand: 'NBA TV: On Demand',
	p_channel_live24x7_collection: 'Collection',
	p_channel_live24x7_demand_1_logo_text: 'original shows',
	p_channel_live24x7_demand_1_show_name: 'NBA TV Shows',
	p_channel_live24x7_demand_1_show_desc: 'Original NBA TV shows including Shaqtin’ a Fool, Beyond the Paint, Game Time and Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'classic games',
	p_channel_live24x7_demand_2_show_name: 'NBA Classic Games',
	p_channel_live24x7_demand_2_show_desc: 'Watch full-length Classic Games, including all finals matchups since 2000, historic league moments and legendary players',

	// Channel: Clips
	p_channel_error_msg: 'Not available yet',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Schedule',

	// NBA TV Shows:
	p_nba_tv_shows: 'NBA TV Shows',
	p_nba_tv_no_access_title: '24/7 NBA: Stay informed with game analysis, studio analysis, original programming, and more!',
	p_nba_tv_no_access_desc: 'Watch live games plus shows and classic games on demand.',
	p_nba_tv_no_access_note: 'Blackouts may apply',

	// tv show item
	tv_show_item_latest_episode: 'latest episode',
	tv_show_item_no_latest_episode: 'no latest episode',
	see_all: 'See All',
	// header
	header_menu_watch: 'Watch',
	header_menu_featured: 'Featured',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: 'PLAYERS',
	videos: 'VIDEOS',
	teams: 'TEAMS',
	most_searched: 'MOST SEARCHED',
	no_result: 'No Data',
	search_filter_type_most_relevant: 'Most relevant',
	search_filter_type_most_viewed: 'Most viewed',
	search_filter_type_most_recent: 'Most recent',
	search_filter_type_last_30_days: 'Last 30 days',
	search_filter_type_last_6_months: 'Last 6 months',
	search_result_label: 'Search results for \'{keyword}\'',
	search_result_info: 'View all results for the {keyword}',
	search_placeholder: 'Search the video library',
	load_more: 'LOAD MORE',

	// button
	button_subscribe: 'subscribe',
	button_sign_in: 'sign in',
	button_tv_provider: 'select tv provider',

	// league page
	p_league_pass_no_access_title: 'Watch games live or on replay on any device, including your computer, smartphone and TV!',
	p_league_pass_no_access_desc: 'Your ticket to the action: watch the whole league or your favorite team, choose a single game, or check out more options.',
	p_league_pass_no_access_note: 'Terms apply',

	// Video
	category_title: 'Video',
	p_video_playlist_title: 'Playlist',
	p_no_access_league_pass_title: 'Unlock NBA League Pass to watch:',
	p_no_access_league_pass_desc: 'Your ticket to the action: watch the whole league or your favorite team, choose a single game, or check out more options.',
	p_no_access_league_pass_terms: 'Terms apply',
	p_no_access_league_pass_geo_desc: 'Based on your current location, you are unable to view this game via NBA League Pass and NBA TV. An archive of these games will be available 3 days after broadcast for NBA League Pass subscribers. Please consult your local TV and radio broadcaster schedules for where to find broadcasts in your area.',
	p_no_access_league_pass_not_found_desc: 'Sorry, the video you requested was not found.',
	p_no_access_event_not_found_desc: 'Sorry, the event you requested was not found.',
	p_no_access_nba_tv_title: 'Unlock NBA TV to watch:',
	p_no_access_nba_tv_desc: 'Watch live games plus shows and classic games on demand.',
	p_no_access_nba_tv_terms: 'Terms apply',
	p_no_access_nba_tv_geo_desc: 'Based on your current location, you are unable to view this game via NBA League Pass and NBA TV. An archive of these games will be available 3 days after broadcast for NBA League Pass subscribers. Please consult your local TV and radio broadcaster schedules for where to find broadcasts in your area.',
	p_no_access_nba_tv_not_found_desc: 'Sorry, the channel you requested was not found.',
	p_no_access_up_next: 'Up Next:',
	p_video_completed_title: 'Playlist Complete',
	p_video_completed_desc: 'Go back to browse or check out the next playlist for you',
	p_video_share_to: 'Share to:',
	p_video_more_to_watch: 'More to Watch:',

	// Event
	p_event_section_title: 'Event',
	p_event_playlist_title: 'Playlist',
	p_event_button_watch: 'Watch',
	p_event_button_listen: 'Listen',
	p_event_button_ticket: 'Ticket',

	// notfound page
	notfound: 'Sorry, the page you requested was not found.',
	notfound_desc: 'Please check the URL for mistakes.<br/>You can also try using the site navigation or search tool to find your content.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'This account has been signed in on other devices and you have reached your streaming device limit. To continue watching, please close another stream or re-login. If you feel you’ve reached this message in error, please reach out to your TV provider.',
	modal_pcm_custom: 'Continue',
	modal_pcm_close: 'Cancel',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'This video cannot be played on your device. Click <a href="https://neulion-a.akamaihd.net/nlweb/h5support/player.html" target="_blank">HERE</a> for more help.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',

	// FreeSample
	freesample_notice_time: 'Time Remaining',
	freesample_notice_title: 'Enjoy Your {0} Minutes of Access',
	freesample_notice_desc: 'Subscribe to a full League Pass package to continue accessing content after your {0} minutes ends.',
	freesample_notice_subscribe_button: 'Subscribe',
	freesample_notice_cancel_button: 'cancel anytime',
	freesample_popup_title: 'YOUR ACCESS HAS ENDED',
	freesample_popup_subtitle: 'Subscribe to League Pass to watch even more great NBA content.',
	freesample_popup_link: 'Learn More',
	freesample_popup_get_minutes_button: 'Get {0} Minutes',

	// Video list
	reg_required_desc: 'You need to sign in to view this content',
	favorite_teams_title: 'Fav Teams',
	bookmarked_title: 'Saved',
	watch_history_title: 'Continue Watching',
	game_schedule_title: 'Game Schedule',
	recommended_title: 'Recommended',
	season_text: 'Season',

	// profile page
	section_information_title: 'My Information',
	section_information_desc: 'Update your personal information',
	section_information_email: 'Email',
	section_information_email_update: 'Update Email Address',
	section_information_password: 'Password',
	section_information_password_update: 'Change Password',
	section_information_social: 'Social Connections',
	section_information_nosocial_message: 'You have no linked accounts.',
	section_information_firstname: 'First Name',
	section_information_lastname: 'Last Name',
	section_information_birth: 'Date of Birth',
	section_information_country: 'Country/Region',
	section_information_postalcode: 'Postal Code',
	section_tv_provider_title: 'My TV Provider',
	section_tv_provider_desc: 'Gain access to live games and streams by your tv provider.',
	section_tv_provider_faq: 'TV Provider FAQs',
	section_tv_provider_sign_out: 'Sign Out',
	section_tv_provider_sign_in: 'Sign Into TV Provider',
	section_fantasy_title: 'Fantasy',
	section_fantasy_desc: 'View your fantasy account information',
	section_fantasy_displayname: 'Display Name:',
	section_marketing_title: 'My Marketing Preferences',
	section_marketing_desc: 'View your marketing communication and user privacy preferences',
	section_marketing_newsletters: 'NEWSLETTERS',
	section_marketing_message: 'NBA Messages and Advertisements',
	section_marketing_personal_title: 'My Personal Information',
	section_marketing_personal_desc: 'Please use my personal information for the NBA to send me messages and advertisements about products and initiatives of the NBA and NBA Partners.',
	section_marketing_update_button: 'Update Marketing Preferences',
	section_ccpa_title: 'Do not sell my personal information',
	section_ccpa_link_url: 'https://privacyportal.onetrust.com/webform/4b9fe937-73ed-43ed-863a-241ac6bfb482/784f7dd4-5b8b-4569-8087-4560abeab57e',

	// profile edit modal
	email_modal_title: 'update email address',
	email_modal_new_email_label: 'new email address',
	email_modal_update: 'update',
	email_modal_cancel: 'cancel',
	password_modal_title: 'change password',
	password_modal_current_label: 'current password',
	password_modal_new_label: 'new password',
	password_modal_confirm_label: 'confirm password',
	password_modal_update: 'update',
	password_modal_cancel: 'Cancel',
	personal_modal_title: 'update personal information',
	personal_modal_email: 'email',
	personal_modal_password: 'password',
	personal_modal_birth: 'date of birth',
	personal_modal_social: 'social connections',
	personal_modal_firstname: 'first name',
	personal_modal_lastname: 'last name',
	personal_modal_country: 'country/region',
	personal_modal_postalcode: 'postal code',
	personal_modal_update: 'update',
	personal_modal_cancel: 'Cancel',

	// payflow
	payflow_profile_name: 'Name:',
	payflow_profile_email: 'Email:',

	// account page
	header_menu_account_my_account: 'My Account',
	header_menu_account_manage_account: 'Manage Account',
	header_menu_account_favorite_teams: 'Favorite Teams',
	header_menu_account_favorite_players: 'Favorite Players',
	header_menu_account_viewing_history: 'Viewing History',
};
